/**
 * Whether the previous history entry is an in-app page worth returning to.
 * React Router keeps `idx` in history.state (0 on a document's first entry, kept on replace),
 * and a page reached through an auth redirect or logout (`state.from`) would only bounce back here.
 *
 * @param {Object} location react-router location
 * @param {Object|null} historyState window.history.state
 * @returns {boolean}
 */
export const canGoBack = (location, historyState) => historyState?.idx > 0 && !location.state?.from;
